import React from 'react'

export function DetailItem({ label, value }) {
    return (
        <div>
            <p className='text-xs uppercase tracking-wide text-gray-500'>{label}</p>
            <p className='mt-0.5 text-sm font-medium text-slate-900 break-words'>{value || '—'}</p>
        </div>
    )
}

export function CloseButton({ onClick }) {
    return (
        <button
            type='button'
            onClick={onClick}
            className='text-gray-400 hover:text-gray-600 focus:outline-none'
            aria-label='Close'
        >
            <svg className='w-6 h-6' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
            </svg>
        </button>
    )
}